<div class="card">
    <div class="card-header">
        <h1>Reporte de Inventario por Proveedor</h1>
    </div>
    <div class="card-body">
        <div class="row align-items-end">
            <!-- Filtro de Fechas -->
            <div class="col-md-3">
                <label for="startDate">Fecha de Inicio:</label>
                <input
                type="date"
                class="form-control"
                id="startDate"
                [(ngModel)]="startDate"
                />
            </div>

            <div class="col-md-3">
                <label for="endDate">Fecha de Fin:</label>
                <input
                type="date"
                class="form-control"
                id="endDate"
                [(ngModel)]="endDate"
                />
            </div>

        <!-- Filtro de Productos -->
        <div class="col-md-4">
            <app-input-autocomplete-selection
            [inputs]="inputs.product"
            [placeholder]="'Ingresa id o nombre de un producto'"
            [filterElements]="filterProducts"
            [typeElements]="'product'"
            [enableSelect]="true"
            (inputMethod)="handleInput($event.event, 'product')"
            (changeMethod)="verifiedInput($event.event, 'product')"
            (changeStatus)="changeStatusInput($event.filterElement, '', 1, 'product')"
            (getTitle)="
                $event.filterElement.title = 
                (($event.filterElement.code) ? $event.filterElement.code + ' - ' : '') + 
                $event.filterElement.name
            ">
            </app-input-autocomplete-selection>
        </div>

        <!-- Botón de Búsqueda -->
        <div class="col-md-2">
            <button
            class="btn btn-primary w-100"
            (click)="executeSearch()">
            🔍 Buscar
            </button>
        </div>
        </div>

        <div class="row">
            <div class="col">
                <div class="table-responsive mt-3">
                <table class="table table-bordered" style="margin-bottom: 0;">
                    <thead>
                    <!-- Fila 1: Meses y Totales -->
                    <tr class="tr-middle text-center">
                        <th rowspan="2">Proveedor</th>
                        <th rowspan="2">Bodega</th>
                        <th rowspan="2">Producto</th>
                        <th *ngFor="let title of titles" colspan="3">{{title}}</th>
                    </tr>
                    <tr class="tr-middle text-center">
                    <ng-container *ngFor="let title of titles">
                        <th>
                        Unidades
                        <i
                            class="fa"
                            (click)="sortByDynamicColumn(title, 'venta'); $event.stopPropagation()"
                            [ngClass]="{
                            'fa-arrow-right-arrow-left': sortColumn !== title + '_venta',
                            'fa-arrow-up-short-wide': sortDirection === 'asc' && sortColumn === title + '_venta',
                            'fa-arrow-down-wide-short': sortDirection === 'desc' && sortColumn === title + '_venta'
                            }"
                        ></i>
                        </th>
                        <th>
                        Costo Unitario
                        <i
                            class="fa"
                            (click)="sortByDynamicColumn(title, 'utilidad'); $event.stopPropagation()"
                            [ngClass]="{
                            'fa-arrow-right-arrow-left': sortColumn !== title + '_utilidad',
                            'fa-arrow-up-short-wide': sortDirection === 'asc' && sortColumn === title + '_utilidad',
                            'fa-arrow-down-wide-short': sortDirection === 'desc' && sortColumn === title + '_utilidad'
                            }"
                        ></i>
                        </th>
                        <th>
                        Total
                        <i
                            class="fa"
                            (click)="sortByDynamicColumn(title, 'total'); $event.stopPropagation()"
                            [ngClass]="{
                            'fa-arrow-right-arrow-left': sortColumn !== title + '_total',
                            'fa-arrow-up-short-wide': sortDirection === 'asc' && sortColumn === title + '_total',
                            'fa-arrow-down-wide-short': sortDirection === 'desc' && sortColumn === title + '_total'
                            }"
                        ></i>
                        </th>
                    </ng-container>
                    </tr>

                    </thead>
                    <tbody>
                    <!-- Proveedor -->
                    <ng-container *ngFor="let provider of paginationProviders.filter">
                        <tr class="fw-bold item tr-middle" (click)="toggleProvider(provider)">
                        <td >
                            <i [ngClass]="provider.expanded ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i>
                            {{provider.name}}
                        </td>
                        <td>{{provider.provider}}</td>
                        <td></td>
                        <ng-container *ngFor="let title of titles">
                            <td>{{provider.monthlySales[title]?.venta | currency:'Q.':'symbol':'1.2-2' }}</td>
                            <td>{{provider.monthlySales[title]?.utilidad | currency:'Q.':'symbol':'1.2-2'}}</td>
                            <td>{{provider.monthlySales[title]?.total | currency:'Q.':'symbol':'1.2-2'}}</td>
                        </ng-container>
                        </tr>

                        <!-- Warehouses -->
                        <ng-container *ngIf="provider.expanded">
                        <ng-container *ngFor="let warehouse of provider.warehouses">
                            <tr class="fw-bold item tr-middle" (click)="toggleWarehouse(warehouse, $event)">
                            <td></td>
                            <td>
                                <i [ngClass]="warehouse.expanded ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i>
                                {{warehouse.name}}
                            </td>
                            <td></td> <!-- Aquí agregamos la celda vacía -->
                            <ng-container *ngFor="let title of titles">
                                <td>{{warehouse.monthlySales[title]?.venta | currency:'Q.':'symbol':'1.2-2'}}</td>
                                <td>{{warehouse.monthlySales[title]?.utilidad | currency:'Q.':'symbol':'1.2-2'}}</td>
                                <td>{{warehouse.monthlySales[title]?.total | currency:'Q.':'symbol':'1.2-2'}}</td>
                            </ng-container>
                            </tr>

                            <!-- Products within Warehouse -->
                            <ng-container *ngIf="warehouse.expanded">
                            <tr *ngFor="let subProduct of warehouse.products" class="item tr-middle">
                                <td></td>
                                <td></td>
                                <td>{{subProduct.name}}</td>
                                <ng-container *ngFor="let title of titles">
                                <td>{{subProduct.monthlySales[title]?.venta | currency:'Q.':'symbol':'1.2-2'}}</td>
                                <td>{{subProduct.monthlySales[title]?.utilidad | currency:'Q.':'symbol':'1.2-2'}}</td>
                                <td>{{subProduct.monthlySales[title]?.total | currency:'Q.':'symbol':'1.2-2'}}</td>
                                </ng-container>
                            </tr>
                            </ng-container>
                        </ng-container>
                        </ng-container>
                    </ng-container>
                    </tbody>
                    <tfoot>
                        <tr class="table-secondary fw-bold text-center">
                            <td colspan="3">Totales</td>
                            <ng-container *ngFor="let title of titles">
                            <td>{{ getTotalVenta(title) | currency:'Q.':'symbol':'1.2-2' }}</td>
                            <td>{{ getTotalUtilidad(title) | currency:'Q.':'symbol':'1.2-2' }}</td>
                            <td>{{ getTotalTotal(title) | currency:'Q.':'symbol':'1.2-2' }}</td>
                            </ng-container>
                        </tr>
                    </tfoot>
                </table>
                </div>
                <app-pagination-custom (changed)="executeSearch()" [elements]="paginationProviders"></app-pagination-custom>
            </div>
        </div>
    </div>
</div>
